import React, { useRef } from "react";
import { Box } from "@mui/material";
import ElementRenderer from "./ElementRenderer";

export default function EditorCanvas({
    canvasSize,
    canvasBg,
    elements,
    selectedId,
    scale,
    containerRef,
    onDeselectAll,
    onElementMouseDown,
    onResizeMouseDown,
}) {
    const canvasRef = useRef(null);
    const sorted = [...elements].sort((a, b) => a.zIndex - b.zIndex);

    return (
        <Box
            ref={containerRef}
            sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "auto",
                p: 3,
                minWidth: 0,
            }}
        >
            {/*
              Outer div takes the scaled visual footprint so flex centering works
              correctly and doesn't overlap sidebars.
            */}
            <div style={{
                width: canvasSize.width * scale,
                height: canvasSize.height * scale,
                position: "relative",
                flexShrink: 0,
            }}>
                {/* Inner canvas at actual dimensions, scaled visually via CSS transform */}
                <div
                    ref={canvasRef}
                    style={{
                        position: "absolute",
                        top: 0, left: 0,
                        width: canvasSize.width,
                        height: canvasSize.height,
                        backgroundColor: canvasBg,
                        boxShadow: "0 6px 30px rgba(0,0,0,0.2)",
                        overflow: "hidden",
                        transform: `scale(${scale})`,
                        transformOrigin: "top left",
                    }}
                    onMouseDown={e => { if (e.target === canvasRef.current) onDeselectAll(); }}
                >
                    {sorted.map(el => (
                        <ElementRenderer
                            key={el.id}
                            el={el}
                            isSelected={el.id === selectedId}
                            onMouseDown={onElementMouseDown}
                            onResizeMouseDown={onResizeMouseDown}
                        />
                    ))}
                </div>
            </div>
        </Box>
    );
}
